import * as React from 'react';
import { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Index } from './Index/Index';
import { MisProcesos } from './MisProcesos/MisProcesos';
import { Proceso } from './Proceso/Proceso';
import { Tasks } from './Tasks/Tasks';
import { Work } from './Work/Work';

function BodyRouter(props) {

    const [openCaseInfo, setOpenCaseInfo] = useState('');

    // Function to load and display each case info
    async function loadCaseBreef(pk) {
            // Load case info
        return fetch(`${props.url}/procesos-api/load-case`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Token '+ localStorage.getItem('token'),
        },
        body: JSON.stringify({pk: pk})
        })
    }

    return (
        <React.Fragment>
            <Routes>
                     <Route  index 
                             element={<Index logged={props.logged} 
                                             setOpenCaseInfo={setOpenCaseInfo} 
                                             url={props.url}
                                             username={props.username}
                                             typeUser={props.typeUser}
                                      />} 
                             exact
                     />
                     <Route path='/mis-procesos' 
                            element={props.logged ? 
                            <MisProcesos setOpenCaseInfo={setOpenCaseInfo}
                                         loadCaseBreef={loadCaseBreef} 
                                         typeUser={props.typeUser}
                                         corporation={props.corporation} 
                                         url={props.url}/> : 
                            <Navigate to='/' replace/>} 
                     />
                     <Route path='/importantes' 
                            element={props.logged ? 
                            <MisProcesos setOpenCaseInfo={setOpenCaseInfo}
                                          loadCaseBreef={loadCaseBreef}
                                          typeUser={props.typeUser}
                                          corporation={props.corporation} 
                                          url={props.url}/> : 
                            <Navigate to='/' replace/>} 
                     />
                     <Route path='/archivados' 
                            element={props.logged ? 
                            <MisProcesos setOpenCaseInfo={setOpenCaseInfo}
                                         loadCaseBreef={loadCaseBreef}
                                         typeUser={props.typeUser}
                                         corporation={props.corporation} 
                                         url={props.url}/> : 
                            <Navigate to='/' replace/>} 
                     />
                     <Route path='/proceso/:id' 
                            element={props.logged ? 
                            <Proceso openCaseInfo={openCaseInfo} 
                                     url={props.url}/> : 
                            <Navigate to='/' replace/>} 
                     />     
                     <Route path='/tasks'
                            element={props.logged && props.typeUser !== 'freemium' ? 
                            <Tasks setOpenCaseInfo={setOpenCaseInfo} 
                                   url={props.url}/> : 
                            <Navigate to='/' replace/>}
                     />
                     <Route path='/work/:id'
                            element={props.logged && props.typeUser !== 'freemium' ? 
                            <Work /> : 
                            <Navigate to='/' replace/>}
                     />
            </Routes>
        </React.Fragment>
        );
  }
  
  export { BodyRouter };